(() => {
  if (window.TMWheelJourney) return;
  const KEY = 'tmWheelJourneyV4';
  const LEGACY_KEY = 'tmWheelAutoFrequencyV3';
  const IDLE = 30 * 60 * 1000;
  const DAY = 24 * 60 * 60 * 1000;
  const GAP = 4 * 60 * 60 * 1000;
  const MAIN_PRODUCTS = new Set([9531976548581, 9714850791653, 9718001336549]);
  const GIFT_PRODUCTS = new Set([...MAIN_PRODUCTS, 9761079689445, 9777591255269, 9777591419109, 9777591615717, 9777591877861]);
  const root = document.querySelector('[data-tm-private-wheel-v2]');
  if (!root) return;
  let memory = null;
  let activityAt = 0;
  let returnedCartAnnounced = false;
  const FLOAT_KEY = 'tmWheelFloatingLauncherClosedV1';
  const floating = root.querySelector('[data-tm-floating-reward]');
  let floatingClosed = false;
  let floatingFrame = 0;
  try { floatingClosed = sessionStorage.getItem(FLOAT_KEY) === '1'; } catch {}
  const positionFloating = () => {
    floatingFrame = 0;
    if (!floating || floating.hidden) return;
    const main = document.getElementById('MainContent')?.getBoundingClientRect();
    const header = document.querySelector('sticky-header')?.getBoundingClientRect();
    const top = Math.max(12, (main?.top || 0) + 12, (header?.bottom || 0) + 12);
    const bottom = Math.min(window.innerHeight - 12, main?.bottom ?? window.innerHeight);
    const height = floating.offsetHeight;
    const overlay = [...document.querySelectorAll('.tm-private-wheel__overlay:not([hidden]), cart-drawer.active, #cart-notification.active, dialog[open], [aria-modal="true"], menu-drawer details[open], #shopify-pc__banner')]
      .some(element => {
        if (element.closest('[hidden], details:not([open])')) return false;
        const style = getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        return style.visibility !== 'hidden' && Number(style.opacity) > 0 && rect.width > 4 && rect.height > 4
          && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
      });
    if (overlay || bottom - top < height + 12) { floating.dataset.obscured = 'true'; return; }
    const rail = floating.getBoundingClientRect();
    const blockers = [];
    const parents = new Map();
    const relevant = rect => rect.width > 0 && rect.height > 0 && rect.right > rail.left - 8 && rect.left < rail.right + 8 && rect.bottom > top && rect.top < bottom;
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const element = node.parentElement;
      if (!node.textContent.trim() || !element || element.closest('[data-tm-floating-reward],script,style,noscript,[hidden],[aria-hidden="true"]')) continue;
      if (!parents.has(element)) parents.set(element, relevant(element.getBoundingClientRect()) && getComputedStyle(element).visibility !== 'hidden');
      if (!parents.get(element)) continue;
      const range = document.createRange();
      range.selectNodeContents(node);
      for (const rect of range.getClientRects()) if (relevant(rect)) blockers.push({ top: rect.top - 8, bottom: rect.bottom + 8 });
    }
    document.querySelectorAll('button,input,select,textarea').forEach(element => {
      if (element.closest('[data-tm-floating-reward],[hidden]')) return;
      const rect = element.getBoundingClientRect();
      if (rect.height <= 120 && relevant(rect) && getComputedStyle(element).visibility !== 'hidden') blockers.push({ top: rect.top - 8, bottom: rect.bottom + 8 });
    });
    const desired = Math.max(top, Math.min(window.innerHeight * .58 - height / 2, bottom - height - 12));
    const current = Number.parseFloat(floating.style.top);
    const anchor = Number.isFinite(current) ? current : desired;
    const candidates = [anchor, desired, top, bottom - height - 12, ...blockers.flatMap(rect => [rect.bottom, rect.top - height])]
      .filter(y => y >= top && y + height <= bottom - 12).sort((a, b) => Math.abs(a - anchor) - Math.abs(b - anchor));
    const position = candidates.find(y => blockers.every(rect => y + height <= rect.top || y >= rect.bottom));
    floating.dataset.obscured = String(position === undefined);
    if (position !== undefined) floating.style.top = Math.round(position) + 'px';
  };
  const scheduleFloating = () => {
    if (!floatingFrame) floatingFrame = requestAnimationFrame(positionFloating);
  };
  const renderFloating = session => {
    if (!floating) return;
    floating.hidden = floatingClosed || !['available', 'claimed'].includes(session?.state);
    if (floating.hidden) return;
    const offer = session.offer || session.renewableOffer;
    const claimed = session.state === 'claimed';
    const saved = Boolean(session.renewableOffer);
    floating.dataset.rewardKind = offer?.kind || 'discount';
    const button = floating.querySelector('[data-tm-reward-open]');
    putText(floating.querySelector('[data-tm-floating-lead]'), saved ? floating.dataset.saved : claimed ? floating.dataset.your : floating.dataset.upTo);
    putText(floating.querySelector('[data-tm-floating-value]'), offer?.kind === 'gift' ? floating.dataset.gift : (offer?.percent || 20) + '%');
    putText(floating.querySelector('[data-tm-floating-action]'), claimed || saved ? floating.dataset.reward : floating.dataset.spin);
    button.setAttribute('aria-label', saved ? floating.dataset.renewLabel : claimed ? floating.dataset.viewLabel : floating.dataset.openLabel);
    scheduleFloating();
  };
  floating?.querySelector('[data-tm-floating-close]')?.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    floatingClosed = true;
    try { sessionStorage.setItem(FLOAT_KEY, '1'); } catch {}
    floating.hidden = true;
    document.getElementById('MainContent')?.focus({ preventScroll: true });
  });
  if (floating) {
    window.addEventListener('scroll', scheduleFloating, { passive: true });
    window.addEventListener('resize', scheduleFloating, { passive: true });
    new MutationObserver(scheduleFloating).observe(root, { attributes: true, subtree: true, attributeFilter: ['hidden'] });
  }
  const read = () => {
    let value = memory;
    try { value = JSON.parse(localStorage.getItem(KEY) || 'null') || value; } catch {}
    if (!value || typeof value !== 'object') {
      let legacy = null;
      try { legacy = JSON.parse(localStorage.getItem(LEGACY_KEY) || 'null'); } catch {}
      value = { shownAt: legacy?.shownAt || [], lastDismissedAt: Number(legacy?.lastDismissedAt) || 0 };
    }
    return { ...value, shownAt: Array.isArray(value.shownAt) ? value.shownAt.map(Number).filter(t => Number.isFinite(t) && t <= Date.now() && Date.now() - t < DAY) : [] };
  };
  const write = value => {
    memory = value;
    try { localStorage.setItem(KEY, JSON.stringify(value)); } catch {}
    return value;
  };
  const touch = (force = false) => {
    if (document.hidden || (!force && Date.now() - activityAt < 10000)) return;
    activityAt = Date.now();
    const state = read();
    if (!state.visitStartedAt || Date.now() - (Number(state.lastActivityAt) || 0) >= IDLE) {
      state.visitStartedAt = Date.now();
      state.visitShown = false;
      state.checkoutAt = 0;
      state.returning = Boolean(state.lastActivityAt);
      try { sessionStorage.removeItem('tmWheelCartJourneyV2'); } catch {}
    }
    state.lastActivityAt = Date.now();
    write(state);
  };
  const track = (eventName, detail = {}) => {
    const state = read();
    const payload = { source: 'tm-wheel-return-v4', policyVersion: 'return-checkout-v4', returningVisit: Boolean(state.returning), ...detail };
    try { window.Shopify?.analytics?.publish?.(eventName, payload); } catch {}
    try { window.dataLayer?.push?.({ event: eventName, ...payload }); } catch {}
    document.dispatchEvent(new CustomEvent('tm:wheel-analytics', { detail: { eventName, ...payload } }));
  };
  const canAuto = () => {
    const state = read();
    const lastShown = Math.max(0, ...state.shownAt);
    return !state.visitShown && state.shownAt.length < 2 && Date.now() - lastShown >= GAP
      && Date.now() - (Number(state.lastDismissedAt) || 0) >= GAP
      && Date.now() >= (Number(state.snoozeUntil) || 0)
      && Date.now() - (Number(state.checkoutAt) || 0) >= IDLE;
  };
  const markAuto = reason => {
    const state = read();
    state.shownAt.push(Date.now());
    state.visitShown = true;
    write(state);
    track('tm_wheel_auto_open', { triggerReason: reason, impressionCount24h: state.shownAt.length });
  };
  const markManual = source => {
    write({ ...read(), visitShown: true });
    track('tm_wheel_manual_open', { placement: source });
  };
  const dismiss = () => {
    const state = read();
    state.lastDismissedAt = Date.now();
    state.dismissStreak = (Number(state.dismissStreak) || 0) + 1;
    if (state.dismissStreak >= 3) state.snoozeUntil = Date.now() + 2 * DAY;
    write(state);
  };
  const markEngaged = () => write({ ...read(), visitShown: true, dismissStreak: 0, snoozeUntil: 0 });
  const markCheckout = () => write({ ...read(), checkoutAt: Date.now(), visitShown: true });
  const putText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const createCard = () => {
    const card = document.createElement('div');
    card.setAttribute('data-tm-reward-card', '');
    card.hidden = true;
    const copy = document.createElement('div');
    copy.append(document.createElement('strong'), document.createElement('p'));
    const button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('data-tm-reward-open', 'cart');
    card.append(copy, button);
    return card;
  };
  const render = () => {
    const service = window.TMCartOfferReservation;
    const session = window.TMPrivateOffers?.getSession?.();
    const cart = service?.getCart?.();
    const gift = (session?.offer || session?.renewableOffer)?.kind === 'gift';
    const products = gift ? GIFT_PRODUCTS : MAIN_PRODUCTS;
    const qualifies = (cart?.items || []).some(item => !item.properties?._tm_wheel_gift && products.has(Number(item.product_id)));
    const applied = service?.state?.().applied === true && session?.state === 'claimed';
    const available = session?.state === 'available';
    const pending = session?.state === 'claimed' && !applied;
    const timers = document.querySelectorAll('[data-tm-offer-timer]:has([data-tm-offer-clock])');
    timers.forEach(timer => {
      const summary = timer.closest('.cart__blocks, .tm-l10n-cart__summary');
      const anchor = summary?.querySelector('[data-tm-checkout-delivery]') || timer;
      let card = summary ? summary.querySelector('[data-tm-reward-card]') : timer.previousElementSibling;
      if (!card?.matches('[data-tm-reward-card]')) {
        card = createCard();
        if (summary) anchor.after(card); else timer.before(card);
      }
      card.hidden = !qualifies || !(available || pending);
      if (card.hidden) return;
      const renewal = session.renewableOffer;
      putText(card.querySelector('strong'), renewal ? 'Your saved reward is ready' : pending ? 'Your reward is ready for your bag' : 'Your private reward');
      putText(card.querySelector('p'), renewal ? (gift ? 'Reactivate your free mystery gift.' : 'Reactivate your ' + renewal.title + '.') : pending ? 'Apply it to see your updated total.' : 'Up to 20% off or a free gift.');
      putText(card.querySelector('button'), renewal ? 'Reactivate reward' : pending ? 'Apply reward' : 'Spin now');
      if (card.getClientRects().length && card.dataset.seen !== session.state + Boolean(renewal)) {
        card.dataset.seen = session.state + Boolean(renewal);
        track('tm_wheel_cart_prompt', { rewardState: session.state, renewal: Boolean(renewal) });
      }
    });
    if (root.dataset.tmProductPage === 'true') {
      document.querySelectorAll('[data-tm-reward-launcher]').forEach(launcher => launcher.remove());
      renderFloating(session);
      if (qualifies && !returnedCartAnnounced && read().returning && !window.TMWheelVisit?.checkoutStarted) {
        returnedCartAnnounced = true;
        window.TMWheelVisit?.markCart?.();
        document.dispatchEvent(new CustomEvent('tm:wheel-return-with-cart'));
      }
    }
  };
  window.TMWheelJourney = { canAuto, markAuto, markManual, dismiss, markEngaged, markCheckout, track, render };
  touch(true);
  ['pointerdown', 'keydown', 'scroll'].forEach(name => document.addEventListener(name, () => touch(), { passive: true }));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { touch(true); render(); } });
  window.addEventListener('pageshow', () => { touch(true); render(); });
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-tm-reward-open]');
    if (!button) return;
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('tm:wheel-manual-open', { detail: { source: button.dataset.tmRewardOpen } }));
  });
  ['tm:private-offer-session', 'cart:refresh', 'tm:cart-add-confirmed'].forEach(name => document.addEventListener(name, render));
  window.addEventListener('storage', event => { if (event.key === KEY) render(); });
  window.setInterval(render, 1000);
  void window.TMPrivateOffers?.ensureSession?.();
  render();
})();
